import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Logo on the landing: stay on this page and show its first block. */
export function scrollLandingToTop(event, pathname) {
  if (pathname !== "/") return;
  event.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" });
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
